var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExclamation = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 13,
  viewBox: "0 0 13 13",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: 1.5,
  d: "M6.5 7V4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.5 8.5h0"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 1.5,
  d: "M6.489 9.25a.246.246 0 0 0-.172.078.246.246 0 0 0-.065.177.254.254 0 0 0 .25.245h.009a.247.247 0 0 0 .237-.255.253.253 0 0 0-.246-.245"
}))));
export { SvgExclamation as ReactComponent };
export default __webpack_public_path__ + "assets/images/exclamation.svg";